module.exports = __webpack_public_path__ + "static/media/cta-background.4c284283.png";